import { fetchAuthSession } from "@aws-amplify/auth";
import axios from "axios";
import {
  ADMIN_AUDBILITY_LOGS,
  ADMIN_AUDBILITY_PATIENTS,
  ADMIN_AUDBILITY_USERS,
} from "../../../../constants/api";

const withAuthHeaders = async (config = {}) => {
  const session = await fetchAuthSession({
    forceRefresh: true,
  });
  const userToken = session.tokens?.idToken?.toString();

  return {
    ...config,
    headers: {
      ...(config.headers || {}),
      ...(userToken ? { Authorization: userToken } : {}),
    },
  };
};

const getUsers = async (params = {}) => {
  const response = await axios.get(
    ADMIN_AUDBILITY_USERS,
    await withAuthHeaders({ params })
  );

  return response.data?.users || [];
};

const getUserBySub = async (sub) => {
  const users = await getUsers({ param: "user_sub", value: sub });

  return users[0] || null;
};

const getUserLogs = async (sub) => {
  const response = await axios.get(
    ADMIN_AUDBILITY_LOGS,
    await withAuthHeaders({ params: { user_sub: sub } })
  );

  return response.data;
};

const getUserPatients = async (sub) => {
  const response = await axios.get(
    ADMIN_AUDBILITY_PATIENTS,
    await withAuthHeaders({ params: { user_sub: sub } })
  );

  return response.data;
};

const getUserPatient = async (sub, patientSub) => {
  const response = await axios.get(
    ADMIN_AUDBILITY_PATIENTS,
    await withAuthHeaders({ params: { user_sub: sub, patient_sub: patientSub } })
  );

  return response.data;
};

export const audbilityApi = {
  getUsers,
  getUserBySub,
  getUserLogs,
  getUserPatients,
  getUserPatient,
};
